import React, { useEffect } from 'react';
import "../../styles/home/achievement-slider.css";
import "@fancyapps/ui/dist/fancybox/fancybox.css"; // Correct path for FancyBox 4
import { Fancybox } from "@fancyapps/ui";
import { useLocation } from 'react-router-dom';


const AchievementSlider = () => {

    const location = useLocation();

    // Initialize FancyBox after component mounts
    useEffect(() => {
        Fancybox.bind("[data-fancybox='gallery']", {
            infinite: false,
            loop: true,
        });


        if (location.hash) {
            const element = document.getElementById(location.hash.substring(1));
            if (element) {
                element.scrollIntoView({ behavior: "smooth" });
            }
        }
    }, [location]);

    return (
        <div className="container achievements" id="achievements">
            <div className="container" style={{ position: "relative" }}>
                <h1 className="my-heading" style={{ paddingLeft: 20 }}>
                    Achievements &amp; Rankings
                </h1>
                <div className="certificates" id="awidth">
                    <div className="card-main">
                        <div className="cards">
                            <div className="card item">
                                <div className="card-image">
                                    <a href="https://cdn.ccsuniversity.ac.in/public/webp/2026/11/up-certificate.jpeg" data-fancybox="gallery">
                                        <img
                                            src="https://cdn.ccsuniversity.ac.in/public/webp/2026/11/up-certificate.jpeg"
                                            alt="achievements"
                                        />
                                    </a>
                                </div>
                            </div>
                            <div className="card item">
                                <div className="card-image">
                                    <a href="https://cdn.ccsuniversity.ac.in/public/webp/2026/09/ccsu%20ranks%202026.webp" data-fancybox="gallery">
                                        <img
                                            src="https://cdn.ccsuniversity.ac.in/public/webp/2026/09/ccsu%20ranks%202026.webp"
                                            alt="achievements"
                                        />
                                    </a>
                                </div>
                            </div>
                            <div className="card item">
                                <div className="card-image">
                                    <a href="../../assets/images/certificate/large/certificate8.jpg" data-fancybox="gallery">
                                        <img
                                            src="../../assets/images/certificate/small/certificate8.jpg"
                                            alt="achievements"
                                        />
                                    </a>
                                </div>
                            </div>
                            <div className="card item">
                                <div className="card-image">
                                    <a href="../../assets/images/certificate/large/certificate1.jpeg" data-fancybox="gallery">
                                        <img
                                            src="../../assets/images/certificate/small/1.png"
                                            alt="achievements"
                                        />
                                    </a>
                                </div>
                            </div>
                            <div className="card item">
                                <div className="card-image">
                                    <a href="../../assets/images/certificate/large/certificate5.jpeg" data-fancybox="gallery">
                                        <img
                                            src="../../assets/images/certificate/small/2.png"
                                            alt="achievements"
                                        />
                                    </a>
                                </div>
                            </div>
                            <div className="card item">
                                <div className="card-image">
                                    <a href="../../assets/images/certificate/large/certificate2.jpeg" data-fancybox="gallery">
                                        <img
                                            src="../../assets/images/certificate/small/3.png"
                                            alt="achievements"
                                        />
                                    </a>
                                </div>
                            </div>
                            <div className="card item">
                                <div className="card-image">
                                    <a href="../../assets/images/certificate/large/certificate3.jpeg" data-fancybox="gallery">
                                        <img
                                            src="../../assets/images/certificate/small/4.png"
                                            alt="achievements"
                                        />
                                    </a>
                                </div>
                            </div>
                            <div className="card item">
                                <div className="card-image">
                                    <a href="../../assets/images/certificate/large/certificate6.jpg" data-fancybox="gallery">
                                        <img
                                            src="../../assets/images/certificate/small/5.png"
                                            alt="achievements"
                                        />
                                    </a>
                                </div>
                            </div>
                            <div className="card item">
                                <div className="card-image">
                                    <a href="../../assets/images/certificate/large/certificate7.jpg" data-fancybox="gallery">
                                        <img
                                            src="../../assets/images/certificate/small/6.png"
                                            alt="achievements"
                                        />
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AchievementSlider;
